import { createFileRoute } from '@tanstack/react-router'
import { ArchiveScreen } from '@/components/qr/archive-screen'
import { BrowserSkeleton, ViewBarSkeleton } from '@/components/shell/screen-skeletons'

export const Route = createFileRoute('/o/$org/archive')({
  pendingComponent: () => (
    <>
      <ViewBarSkeleton />
      <BrowserSkeleton />
    </>
  ),
  component: ArchiveScreen,
})
